export const ROOT_PATH = "/workspaces";

function encodePath(path: string): string {
	return path
		.split("/")
		.map(component => encodeURIComponent(component))
		.join("/");
}

export function workspacePath(orgId: string, workspaceId: string, path?: string, query?: string, hash?: string): string {
	const routePath = path ? encodePath(path) : "home";
	return `/${orgId}/workspaces/${workspaceId}/${routePath}${query ? "?" + query : ""}${hash ? "#" + hash : ""}`;
}

export function workspaceAdminPath(orgId: string, workspaceId: string, path?: string, queryString?: string, hash?: string): string {
	return workspacePath(orgId, workspaceId, `admin${path ? "/" + encodePath(path) : ""}`, queryString, hash);
}

export function conversionPath(orgId: string, workspaceId: string, suiteId: string, query?: string): string {
	return `/${orgId}/workspaces/${workspaceId}/conversions/${suiteId}${query ? "?" + query : ""}`;
}

export function contactsPath(orgId: string, workspaceId: string, email: string): string {
	return `/${orgId}/workspaces/${workspaceId}/contacts/${email}`;
}

export function adminPath(orgId: string, path?: string, queryString?: string, hash?: string): string {
	return `/${orgId}/admin${path ? "/" + encodePath(path) : ""}${queryString ? "?" + queryString : ""}${hash ? "#" + hash : ""}`;
}

export function corpPath(corpId: string, path?: string): string {
	return `/corporations/${corpId}${path ? "/" + encodePath(path) : ""}`;
}

export function viewerPath(path?: string): string {
	return `/r${path ? "/" + encodePath(path) : ""}`;
}

export function orgAdminUsers({ orgId }: { orgId: string }): string {
	return `/${orgId}/admin/users`;
}

export function orgAdminUserWorkspaces({ orgId, userId }: { orgId: string; userId: string }): string {
	return `/${orgId}/admin/users/${userId}/workspaces`;
}

export function workspaceOrAdminPath(orgId: string, workspaceId: string | undefined, path?: string) {
	if (workspaceId !== undefined && workspaceId !== "") {
		return workspacePath(orgId, workspaceId, path);
	} else {
		return adminPath(orgId, path);
	}
}

export function workspaceDashboardPath(orgId: string, workspaceId: string, dashboardId: string, query?: string): string {
	return `/${orgId}/workspaces/${workspaceId}/dashboards/${dashboardId}${query ? "?" + query : ""}`;
}

export function adminDashboardPath(orgId: string, dashboardId: string, query?: string): string {
	return `/${orgId}/admin/dashboards/${dashboardId}${query ? "?" + query : ""}`;
}
